@if (!!alert?.text) {
	<div animate.enter="fade-in" animate.leave="fade-out">
		@defer {
			<lib-alert-ui [positionClass]="alertCssClass" [displayType]="alert?.displayType">
				{{ alert?.text }}
			</lib-alert-ui>
		}
	</div>
}
